import { useRef, useState } from 'react';
import { Button, Collapse } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import { ActaWithFirma, useActas } from '../../../../appStore/actas';
import { cleanMsg, postAvanzar, useConvocatoria } from '../../../../appStore/convocatoria';
import { useConcurso } from '../../../../providers/ConcursoProvider';
import AlertDialog from '../../../CompUtils/AlertDialog';
import FullLoading from '../../../CompUtils/FullLoading';
import { SuccessErrorDlg } from '../../../CompUtils/SuccessErrorDlg';
import { finEtapa } from '../gestionConcursoSlice';
import { FirmaBajoConformidad } from '../ListadoActas/FirmaBajoConformidad';

const HorizontalDiv = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  margin-bottom: 16px;
`;

const MarginButton = styled(Button)`
  margin-left: 8px;
  margin-right: 8px;
`;

// type ConfirmationType = 'FIRMA' | 'LEGALES' | null;
export const VerActaEvolucionar = () => {
  const firmarRef = useRef<ActaWithFirma | null>(null);
  const [confirmation, setConfirmation] = useState(false);
  const [firmaPopup, setFirmaPopup] = useState(false);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const history = useHistory();

  const { idLlamadoConcurso } = useConcurso();
  const { file, actas } = useActas();
  const { loading, success, error } = useConvocatoria();

  return (
    <>
      {file && (
        <HorizontalDiv>
          <MarginButton onClick={() => setVisible((e) => !e)} variant="link">
            <i className={`fa fa-lg fa-eye${visible ? '-slash' : ''}`}></i>
            {!visible ? 'Ver acta' : 'Ocultar acta'}
          </MarginButton>
          <MarginButton
            variant="primary"
            onClick={() => {
              if (!actas) throw Error('No se encontró la primer acta');
              firmarRef.current = actas[0];
              setFirmaPopup(true);
            }}>
            <i className={`icono-arg-firma-contrato`}></i>
            Firmar Acta
          </MarginButton>
          <MarginButton onClick={() => setConfirmation(true)} variant="success">
            Enviar a Legales
          </MarginButton>
        </HorizontalDiv>
      )}
      <Collapse in={visible}>
        <embed src={file} type="application/pdf" width="100%" height="600px" />
      </Collapse>
      <FullLoading show={loading} />
      <AlertDialog
        btns={['close']}
        show={!!firmaPopup}
        icon="question"
        title="Concursar"
        onClose={() => setFirmaPopup(false)}
        subtitle={
          <FirmaBajoConformidad
            onClose={() => {
              firmarRef.current = null;
              setFirmaPopup(false);
            }}
            idFirmaActa={firmarRef.current?.idFirmaActa || 0}
          />
        }
      />
      <AlertDialog
        onClose={(wasAccepted) => {
          if (wasAccepted) {
            dispatch(postAvanzar({ idLlamadoConcurso }));
          }

          setConfirmation(false);
        }}
        show={confirmation && !loading}
        icon={'question'}
        title={'Concursar'}
        subtitle={'El concurso se enviará a legales. ¿Desea continuar?'}
      />
      <SuccessErrorDlg
        success={success}
        error={error}
        onClose={() => {
          if (success.toLocaleLowerCase().includes('requisito')) {
            dispatch(cleanMsg());
            return;
          }

          dispatch(cleanMsg());
          if (success) {
            dispatch(finEtapa());
            history.replace('/concursos');
          }
        }}
      />
    </>
  );
};
